import Axios from 'axios';
import { action, observable, computed } from 'mobx';
import without from 'lodash/without';
import Cookies from 'js-cookie';
import type { MomentInput } from 'moment';

import { BigNumber } from 'bignumber.js';
import { message } from 'antd';
import { API } from '../config/api';
import { getDomain, getExchangeUrl, getExchangeOrigin, isSpotPage } from '@/utils/location';
import { CURRENCY_LIST, CurrencyCode, CurrencyItem, LANG_LIST, LangCode, LangItem, getDefaultCurrencyByLang } from '@/config/const';
import { OrderParams, PageInfo, ScrollPageInfo } from '@/models/spotData';
import i18n from '@/i18n';
import { getMainDomain } from '@/utils/utils';

interface AccountInfo {
  accountId: number;
  allowOpenPosition: boolean; // 是否可开仓
  allowTrade: boolean; // 是否可以交易
  allowTransfer: boolean; // 是否可以划转
  openTime: number;
  state: number;
  userGroupId: number;
  userId: number;
}
interface CoinAddress {
  account: string;
  coinType: string;
  memo: string;
  address: string;
}

// 从现货api获取
interface UserInfo {
  [x: string]: MomentInput;
  siteAuditHeadPortrait: string | null
  siteAuditNickname: string
  siteHeadPortraitAuditChanged: number
  siteNicknameAuditChanged: number
  siteProfileAuditChangeType: string
  siteProfileAuditRejectReason: string | null
  siteProfileAuditStatus: number
  username: string;
  lastAuthTime: number;
  roles: any;
  idNoStatus: number;
  realAuth: number;
  inviteCode: string;
  realName: string;
  createTime: string;
  initialAuth: number;
  headPortrait: string;
  authType: number;
  email: string;
  backReason: string;
  tel: string;
  nickname: string;
  telCountryCode: string;
  id: number;
  emailSecurityStatus: number;
  googleSecurityStatus: number;
  phoneSecurityStatus: number;
  securityLevel: number;
}
export interface LoginUserName {
  username: string;
  telCountryCode: string;
  password: string;
}
interface LoginTokenInfo {
  code: number;
  msg: string;
  data: string;
}
export default class Account {
  @observable accountInfo?: AccountInfo | undefined;

  @observable userInfo: UserInfo;

  @observable coinAddress: CoinAddress;

  @observable listenKey: string;

  @observable collectionList: string[];

  @observable currency: CurrencyCode;

  @observable lang: LangCode;

  @observable assistPriceMap: { [key: string]: string };

  @observable isShowOpenModal: boolean;

  @observable token: string;

  @observable judgeToken: string;

  @observable wsToken: string;

  @observable inviteCount: number;

  @observable total: number;

  @observable inviteUrl: string;

  @observable googleQr: string;

  @observable rewardAmount: string;

  @observable addressUserId: string;

  @observable invitedList: any[];

  @observable invitationList: any[];

  @observable apiList: any[];

  @observable loginRecord: any[];

  @observable addressList: any[];

  @observable countryList: any[];

  @observable delLoading: boolean; // 删除地址loading

  @observable isShowAddress: boolean; // 是否展示充值地址

  @observable isInsideAddres: boolean; // 是否展示充值地址

  @observable isFetchingAddressList: boolean;

  @observable isFetchingLoginRecord: boolean;

  @observable loginFisrtStepVisible: boolean;

  @observable loginSeconStepVisible: boolean;

  @observable loginLastStepVisible: boolean;

  @observable loginRecordPageInfo: PageInfo;

  @observable alwaysSportListenKey: string;

  @observable loginUserName: LoginUserName;

  @observable loginTokenInfo: LoginTokenInfo;

  @observable geeResult: any;
  @observable znxSystemList: any;
  @observable znxDwList: any;
  @observable znxSafeList: any;
  @observable znxAuthList: any;
  @observable znxCopyList: any;
  @observable znxContractList: any;
  @observable znxListAll: any;
  @observable znxPageInfo: ScrollPageInfo;

  @observable znxCurrentTab: string;

  assistPriceTimer: any;

  constructor() {
    this.googleQr = ''; // 谷歌二维码addressUserId
    this.addressUserId = ''; // 提现地址对应的userid
    this.rewardAmount = ''; // 累计返佣金额
    this.addressList = []; // 地址薄
    this.accountInfo = undefined;
    this.inviteUrl = '';
    this.delLoading = false;
    this.total = 0; // 邀请返佣
    this.userInfo = {
      siteAuditHeadPortrait: '',
      siteAuditNickname: '',
      siteHeadPortraitAuditChanged: 0,
      siteNicknameAuditChanged: 0,
      siteProfileAuditChangeType: '',
      siteProfileAuditRejectReason: null,
      siteProfileAuditStatus: 0,
      headPortrait: '',
      username: '',
      lastAuthTime: 0,
      roles: undefined,
      idNoStatus: 0, // 认证状态
      realAuth: 0,
      inviteCode: '',
      initialAuth: 0,
      authType: 0,
      email: '',
      tel: '',
      backReason: '',
      createTime: '',
      id: 0,
      realName: '',
      nickname: '',
      emailSecurityStatus: 0,
      googleSecurityStatus: 0,
      phoneSecurityStatus: 0,
      telCountryCode: '',
      securityLevel: 1,
    };
    this.listenKey = '';
    this.collectionList = [];
    this.loginRecord = []; // 登陆日志
    this.invitedList = [];
    this.invitationList = [];
    (this.apiList = []), (this.currency = '');
    this.lang = '';
    this.assistPriceMap = {};
    this.assistPriceTimer = null;
    this.isShowOpenModal = false;
    this.isInsideAddres = false; // 是否内部地址
    this.isShowAddress = false; // 是否展示充值地址
    this.token = '';
    this.judgeToken = '';
    this.wsToken = '';
    this.inviteCount = 0;
    this.coinAddress = {
      account: '0',
      address: '',
      coinType: '',
      memo: '',
    };
    this.isFetchingAddressList = false;
    this.isFetchingLoginRecord = false;

    this.loginRecordPageInfo = {
      page: 1,
      size: 10,
      total: 0,
    };
    this.alwaysSportListenKey = '';
    this.loginFisrtStepVisible = false; // 登录第一步 输入账号
    this.loginSeconStepVisible = false; // 是登录第二步 输入密码址=
    this.loginLastStepVisible = false; // 、、登录第三步 输入验证码
    this.countryList = [];
    this.loginUserName = {
      username: '',
      telCountryCode: '86',
      password: '',
    };
    this.loginTokenInfo = {
      code: -10024,
      msg: '',
      data: '',
    };
    this.geeResult = null;
    this.znxSystemList = {};
    this.znxDwList = {};
    this.znxSafeList = {};
    this.znxAuthList = {};
    this.znxCopyList = {};
    this.znxContractList = {};
    this.znxListAll = {};
    this.znxPageInfo = {
      hasPrev: false,
      hasNext: false,
    };
    this.znxListAll = {};
    this.znxCurrentTab = 'SYSTEM';
  }

  @computed get userId() {
    return this.accountInfo?.userId;
  }
  @computed get inviteAllUrl() {
    return this.inviteUrl + this.userInfo?.inviteCode;
  }
  // 最近一条登录日志时间数据
  @computed get loginRecordLasted() {
    return this.loginRecord[0]?.createTime;
  }

  @computed get googleAccess() {
    let str = '';
    if (this.googleQr) {
      const e = this.googleQr;
      const startp = window.parseInt(e.indexOf('secret=')) + 7;
      const endp = e.indexOf('&');
      str = e.substring(startp, endp);
    }
    return str;
  }

  @computed get userName() {
    return this.userInfo?.username;
  }
  @computed get znxListInfo() {
    switch (this.znxCurrentTab) {
      case 'SYSTEM':
        return this.znxSystemList;

      case 'DEPOSIT_WITHDRAW':
        return this.znxDwList;
      case 'SAFE':
        return this.znxSafeList;
      case 'AUTH':
        return this.znxAuthList;
      case 'COPY_ORDER':
        return this.znxCopyList;
      case 'CONTRACT':
        return this.znxContractList;
      default:
        return this.znxSystemList || {};
    }
  }
  @computed get systemCircle() {
    return this.znxSystemList?.items?.some(item => !item.read);

    //  return this.znxListAll && this.znxListAll['SYSTEM'] && this.znxListAll['SYSTEM'].items.some(item => !item.read);
  }
  @computed get dwCircle() {
    return this.znxDwList?.items?.some(item => !item.read);
  }
  @computed get safeCircle() {
    return this.znxSafeList?.items?.some(item => !item.read);
  }
  @computed get authCircle() {
    return this.znxAuthList?.items?.some(item => !item.read);
  }
  @computed get copyOrderCircle() {
    return this.znxCopyList?.items?.some(item => !item.read);
  }
  @computed get contractCircle() {
    return this.znxContractList?.items?.some(item => !item.read);
  }

  @computed get showTel() {
    if (this.userInfo?.tel) {
      let str = this.userInfo?.tel;
      // str = str.substring(0, 3) + '****' + str.substring(str.length - 4);
      // return str;
      if (/^\d{11}$/.test(str)) {
        return `${str.slice(0, 3)}****${str.slice(-4)}`;
      }

      // 处理其他格式（比如座机、部分国际号码）
      if (/^\d+$/.test(str)) {
        return `${str.slice(0, 2)}****${str.slice(-2)}`;
      }
    }
    return '';
  }

  @computed get showEmail() {
    if (this.userInfo?.email) {
      const email = this.userInfo?.email;
      // const str = email.split('@');
      // const str0 = str[0].substring(0, 3) + '****' + str[0].substring(str[0].length - 3);
      // return str0 + '@' + str[1];
      const [name, domain] = email.split('@');
      if (name.length <= 3) {
        return `***@${domain}`; // 如果用户名太短
      }
      return `${name.slice(0, 3)}***@${domain}`;
    }
    return '';
  }
  @computed get showUserName() {
    if (this.userInfo.username.includes('@')) {
      return this.showEmail
    } else {
      return this.showTel
    }
  }

  @computed get isLogin() {
    return this.token || Cookies.get('token');
  }

  @computed get hasOpened() {
    return this.accountInfo === undefined || this.accountInfo?.accountId;
  }

  @action.bound
  setLoadingState(key: string, data: boolean) {
    // @ts-ignore
    this[key] = data;
  }

  @action.bound
  setLoginRecordPageInfo(data: PageInfo) {
    const origin = { ...this.loginRecordPageInfo };
    this.loginRecordPageInfo = { ...origin, ...data };
  }

  // 动态获取主域名的函数
  @action.bound
  getMainDomain() {
    const hostname = window.location.hostname; // 获取当前域名
    const parts = hostname.split('.');
    // 保证主域名至少有两部分（比如：`hashex.vip` 或 `example.co.uk`）
    if (parts.length > 2) {
      return `.${parts.slice(-2).join('.')}`; // 取最后两部分作为主域名
    }
    return `.${hostname}`; // 返回当前域名（本地测试时适用）
  }
  @action.bound
  setSharedCookie(name: string, value: string | undefined, options = {}) {
    const domain = this.getMainDomain(); // 动态获取主域名
    const cookieStr = `${name}=${value}; path=/; domain=${domain}; secure; SameSite=None;`;
    document.cookie = cookieStr;
  }

  @action.bound
  async setTicAndUc(data) {
    const { token } = data;
    this.token = token;
    this.setSharedCookie('token', token);
    Cookies.set('token', token);
  }

  // 国家码
  @action.bound
  async setGeeResult(data: any) {
    this.geeResult = data;
  }

  // 国家码
  @action.bound
  async setCountryList(data: any) {
    this.countryList = data;
  }

  @action.bound
  async setLoginUserName(data: LoginUserName) {
    this.loginUserName = data;
  }

  // 、、登录第一步 输入账号
  @action.bound
  async setLoginFisrtStepVisible(data: boolean) {
    this.loginFisrtStepVisible = data;
  }

  // 、、登录第二步 输入密码
  @action.bound
  async setLoginSeconStepVisible(data: boolean) {
    this.loginSeconStepVisible = data;
  }

  // 、、登录第三步 输入验证码
  @action.bound
  async setLoginLastStepVisible(data: boolean) {
    this.loginLastStepVisible = data;
  }

  @action.bound
  async setJudgeToken(data) {
    this.judgeToken = data;
  }

  @action.bound
  async setWsToken(res) {
    this.wsToken = res;
    Cookies.set('ws-token', res);
  }

  @action.bound
  setAccountInfo(data: AccountInfo) {
    this.accountInfo = data;
  }

  @action.bound
  setCoinAddress(data: CoinAddress) {
    this.coinAddress = { ...data, address: data.account || '', account: '0' };
  }

  @action.bound
  setToken(data: string) {
    this.token = data;
  }

  @action.bound
  async fetchAccountInfo() {
    const result: AccountInfo = await Axios.get(API.ACCOUNT_INFO);
    this.setAccountInfo(result);
  }
  @action.bound
  setRewardAmount(data: any) {
    this.rewardAmount = data;
  }
  @action.bound
  setUserInfo(data: UserInfo) {
    this.userInfo = data;
  }

  @action.bound
  setInviteUrl(data: string) {
    this.inviteUrl = data;
  }

  @action.bound
  setInvitedList(res: any) {
    const { items, total } = res;
    this.total = total;
    this.invitedList = items;
  }

  @action.bound
  setInvitationList(res: any) {
    const { items, total } = res;
    this.total = total;
    this.invitationList = items;
  }

  @action.bound
  setLoginRecord(data) {
    this.loginRecord = data;
  }

  @action.bound
  setAddressUserId(res: any) {
    this.addressUserId = res;
  }

  @action
  toSignIn() {
    window.location.href = '/login';
  }

  @action
  toSignUp() {
    window.location.href = '/register';
  }

  @action
  loginOut() {
    Cookies.remove('token', { domain: getMainDomain(), path: '/' });
    Cookies.remove('ws-token');
  }

  @action.bound
  toSignOut() {
    Axios.post(getExchangeUrl().safelyLogout, {
      // headers: {
      //   device: 'web',
      // },
    })
      .then(res => {
        Cookies.remove('token');
        Cookies.remove('token', { domain: getMainDomain(), path: '/' });
        Cookies.remove('ws-token');
        localStorage.removeItem('token');
        sessionStorage.removeItem('listenKey');
        sessionStorage.removeItem('alwaysSportListenKey');
        window.location.href = '/';
      })
      .catch(e => {
        if (e.returnCode === 0) {
          Cookies.remove('token');
          Cookies.remove('token', { domain: getMainDomain(), path: '/' });
          Cookies.remove('ws-token');
          localStorage.removeItem('token');
          sessionStorage.removeItem('listenKey');
          sessionStorage.removeItem('alwaysSportListenKey');
          // 去登录页面
          window.location.href = '/';
          // 退出提醒
          message.success(e.msgInfo);
        }
      });
  }

  @action.bound
  async fetchAccountCancellation(data) {
    const result: any = await Axios.post(getExchangeUrl().accountCancellation, data).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      message.success(i18n.t('common.desSuccess'));
      Cookies.remove('token');
      Cookies.remove('token', { domain: getMainDomain(), path: '/' });
      Cookies.remove('ws-token');
      localStorage.removeItem('token');
      sessionStorage.removeItem('listenKey');
      sessionStorage.removeItem('alwaysSportListenKey');
      window.location.href = '/';
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }

  @action.bound
  fetchUserInfo() {
    Axios.get(getExchangeUrl().getUserInfo, {
      headers: {
        device: 'web',
      },
    })
      .then((result: any) => {
        if (result) {
          this.setUserInfo(result);
        }
      })
      .catch(({ returnCode }) => {
        // 用户不存在
        if (returnCode === 303) {
          this.toSignOut();
        }
      });
  }

  // 收藏列表

  @action.bound
  setCollectionList(data: string[]) {
    this.collectionList = data;
  }

  // 地地址薄
  @action.bound
  setAddressList(data) {
    this.addressList = data;
  }

  @action.bound
  setApiList(data) {
    const { totalCount, list } = data;
    this.total = totalCount;
    this.apiList = list;
  }

  @action.bound
  setInviteCount(data) {
    this.inviteCount = data;
  }

  @action.bound
  setGoogleQr(data) {
    this.googleQr = data;
  }

  @action.bound
  setLoginTokenInfo(data: any) {
    this.loginTokenInfo = data;
  }
  @action.bound
  setZnxCurrentTab(data: string) {
    this.znxCurrentTab = data;
    // if (this.znxListAll) {
    //   const { items, hasPrev, hasNext } = this.znxListAll[data];
    //   this.setZnxPageInfo({ hasPrev, hasNext });
    //   this.setZnxList(items);
    // }
  }
  @action.bound
  async fetchCollectionList() {
    const result: any = await Axios.get(API.COLLECTION_LIST);

    if (result) {
      this.setCollectionList(result);
    }
  }

  @action.bound
  addCollection(symbol: string) {
    if (!this.collectionList.includes(symbol)) {
      const result = [...this.collectionList];
      result.push(symbol);
      this.setCollectionList(result);
      localStorage.setItem('collection-symbols', JSON.stringify({ market: result }));
    }
  }

  @action.bound
  removeCollection(symbol: string) {
    const originList = [...this.collectionList];
    const result = without(originList, symbol);

    this.setCollectionList(result);
    localStorage.setItem('collection-symbols', JSON.stringify({ market: result }));
  }

  @action.bound
  async fetchAddCollection(symbol: string, isFuture: boolean) {
    const result: any = await Axios.post(isFuture ? API.COLLECTION_ADD : API.SPOT_COLLECTION_ADD, { symbol });

    if (result === true) {
      if (!this.collectionList.includes(symbol)) {
        symbol.includes(',')
          ? this.setCollectionList([...this.collectionList, ...symbol.split(',')])
          : this.setCollectionList([...this.collectionList, symbol]);
      }
    }
  }

  @action.bound
  async fetchCancelCollection(symbol: string, isFuture: boolean) {
    const result: any = await Axios.post(isFuture ? API.COLLECTION_CANCEL : API.SPOT_COLLECTION_CANCEL, { symbol });

    if (result === true) {
      this.setCollectionList(without(this.collectionList, symbol));
    }
  }

  // listen key
  @action.bound
  setListenKey(data: string) {
    this.listenKey = data;
    sessionStorage.setItem('listenKey', data);
  }

  // listen key
  @action.bound
  setAlwaysSportListenKey(data: string) {
    this.alwaysSportListenKey = data;
    sessionStorage.setItem('alwaysSportListenKey', data);
  }
  @action.bound
  async fetchListenKey() {
    const result: any = await Axios.get(isSpotPage() ? API.SPOT_LISTEN_KEY : API.LISTEN_KEY);

    if (result) {
      this.setListenKey(result);
    }
  }

  @action.bound
  async fetchAlwaysSportListenKey() {
    const result: any = await Axios.get(API.SPOT_LISTEN_KEY);
    if (result) {
      this.setAlwaysSportListenKey(result);
    }
  }

  @action.bound
  setLang(data: LangCode, isUpdateStore = true) {
    const temp = LANG_LIST.findIndex((item: any) => data === item.value) > -1 ? data : 'en';
    const defaultCurrency = getDefaultCurrencyByLang(temp);
    console.log('temp', temp);
    if (isUpdateStore) {
      this.lang = temp;
    }

    // 同步当前站点 Cookie，避免旧值导致请求头语言回退为 en。
    Cookies.set('lang', temp);
    this.setSharedCookie('lang', temp);
    localStorage.setItem('lang', temp);
    document.querySelector('html')?.setAttribute('lang', temp);
    this.setCurrency(defaultCurrency);
  }

  @computed get langObj(): LangItem {
    return LANG_LIST.find((item: LangItem) => this.lang === item.value) || { label: '', value: '' };
  }

  @action.bound
  setCurrency(data: CurrencyCode) {
    this.currency = data;
    Cookies.set('currency', data);
    localStorage.setItem('currency', data);
  }

  @computed get currencyConfig(): CurrencyItem {
    return (
      CURRENCY_LIST.find((item: CurrencyItem) => this.currency === item.value) || {
        label: '',
        value: '',
        note: '',
      }
    );
  }

  @action.bound
  setAssistPriceMap(data: any) {
    if (data) {
      this.assistPriceMap = data;
    }
  }

  // 汇率
  @action.bound
  async fetchAssistPriceMap() {
    const result: any = await Axios.get(getExchangeUrl().getAssistPrice);
    if (result) {
      this.setAssistPriceMap(result);
    }
  }

  @action.bound
  clearAssistPriceTimer() {
    if (this.assistPriceTimer) {
      clearTimeout(this.assistPriceTimer);
    }
  }
  // @action.bound
  // setZnxList(data: any) {
  //   this.znxList = data;
  // }
  @action.bound
  setZnxList(key: string, data: boolean) {
    // @ts-ignore
    this[key] = data;
  }
  @action.bound
  setZnxListAll(data: any) {
    this.znxListAll = data;
  }
  @action.bound
  setZnxPageInfo(data: ScrollPageInfo) {
    const origin = { ...this.znxPageInfo };
    this.znxPageInfo = { ...origin, ...data };
  }

  /**
   * 获取资产指定币种折合价
   * @param number 数量，譬如 200
   * @param coin 币种
   * @param targetCoin 货币类型，默认是当前货币类型
   * @param price 最新价，当 getAssistPrice 数据中没有价格时使用
   * @param priceCurrency 最新价的计价单位
   */
  @action.bound
  getCoinValue(number: string | number, coin?: string, targetCoin?: string, price?: string, priceCurrency?: string) {
    const currency = targetCoin || this.currency;
    const assistPrice = this.assistPriceMap;

    let result = new BigNumber(0);
    if (assistPrice) {
      // let currency2RmbPrice = assistPrice[currency]; // 当前货币折合rmb价格
      let currency2RmbPrice = assistPrice[coin]; // 目前只有人民币价格

      // 若辅助币种是人民币则辅助价格为1
      // 原因：getAssistPrice api 的返回数据中没有cny
      if (currency === 'cny') {
        currency2RmbPrice = '1';
      }

      if (currency2RmbPrice) {
        if (price && priceCurrency) {
          const p = assistPrice[priceCurrency];
          result = new BigNumber(number || 0)
            .times(price)
            .times(p)
            .div(currency2RmbPrice);
        } else {
          // @ts-ignore
          const coinPrice = assistPrice[coin?.toLowerCase()];
          if (coinPrice) {
            result = new BigNumber(number || 0).times(coinPrice).div(currency2RmbPrice);
          } else if (price) {
            const usdtPrice = assistPrice['usdt'];
            result = new BigNumber(number || 0)
              .times(price)
              .times(usdtPrice)
              .div(currency2RmbPrice);
          }
        }
      }
    }

    let maxPrecision = 0;

    if (['usd', 'cny'].includes(currency)) {
      if (result.abs().gte(0.01)) {
        maxPrecision = 2;
      } else if (result.abs().gte(0.0001)) {
        maxPrecision = 4;
      } else if (result.abs().gte(0.000001)) {
        maxPrecision = 6;
      } else if (result.abs().gte(0.00000001)) {
        maxPrecision = 8;
      }
    } else if (currency === 'btc') {
      if (result.abs().gte(0.00000001)) {
        maxPrecision = 8;
      } else {
        maxPrecision = 16;
      }
    } else if (currency === 'krw') {
      maxPrecision = 0;
    } else {
      maxPrecision = 2;
    }
    const precision = Math.min(maxPrecision, result.toFixed().split('.')[1]?.length || 0);

    return result.isNaN() ? '0' : result.toFixed(precision, 1);
  }

  @action.bound
  setIsShowOpenModal(data: boolean) {
    this.isShowOpenModal = data;
  }

  @action.bound
  async secondSuffix(data) {
    const result: any = await Axios.post(getExchangeUrl().suffix, data).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      this.setTicAndUc(result);
      return Promise.resolve(result);
    }
  }

  // 邀请人数
  @action.bound
  async fetchInviteCount() {
    const result: any = await Axios.get(getExchangeUrl().invitedPeople);
    if (result) {
      this.setInviteCount(result);
    }
  }

  // // 邀请链接
  @action.bound
  async fetchInviteUrl() {
    const result: any = await Axios.get(getExchangeUrl().invitedUrl);

    if (result) {
      this.setInviteUrl(result);
    }
  }

  // 邀请返佣
  @action.bound
  async fetchInvitedList(params: any) {
    const result: any = await Axios.get(getExchangeUrl().invitedInfo, { params });

    if (result) {
      this.setInvitedList(result);
    }
  }
  //累计返佣金额
  @action.bound
  async fetchRewardAmount() {
    const result: any = await Axios.get(getExchangeUrl().rewardAmount);

    if (result) {
      this.setRewardAmount(result);
    }
  }
  // 返佣记录
  @action.bound
  async fetchinvitationList(params: any) {
    const result: any = await Axios.get(getExchangeUrl().invitationList, { params });

    if (result) {
      this.setInvitationList(result);
    }
  }
  // 新增api
  @action.bound
  async fetchAddApi(data) {
    const result: any = await Axios.post(getExchangeUrl().addApi, data).catch(({ error }: any) => {
      message.error(error);
    });
    if (result) {
      this.fetchApiList();
    }

    return Promise.resolve(result);
  }
  // api列表
  @action.bound
  async fetchApiList(params) {
    const result: any = await Axios.get(getExchangeUrl().apiUserList, { params });

    if (result) {
      this.setApiList(result);
    }
  }

  // api删除
  @action.bound
  async fetchDelApi(params) {
    const result: any = await Axios.get(getExchangeUrl().deleteApi, { params }).catch(({ error }: any) => {
      message.error(error);
    });

    this.fetchApiList();
  }
  // api修改
  @action.bound
  async fetchUpdateApi(params) {
    const result: any = await Axios.get(getExchangeUrl().updateApi, { params }).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      message.success(i18n.t('common.modifiedSuccess'));
      this.fetchApiList();
    }

    return Promise.resolve(result);
  }
  @action.bound
  async getWsToken() {
    const result: any = await Axios.get(getExchangeUrl().wsToken);

    if (result) {
      this.setWsToken(result);
    }
  }

  // 绑定邮箱
  @action.bound
  async fetchSecurityEmail(data) {
    const result: any = await Axios.post(getExchangeUrl().securityEmail, data).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      message.success(i18n.t('common.bindSuccess'));
      this.fetchUserInfo();
      return Promise.resolve(result);
    }
  }

  // 绑定手机
  @action.bound
  async fetchSecurityPhone(data) {
    const result: any = await Axios.post(getExchangeUrl().securityPhone, data).catch(({ error }: any) => {
      message.error(error);
      return false;
    });

    if (result) {
      message.success(i18n.t('common.bindSuccess'));
      this.fetchUserInfo();
      return Promise.resolve(result);
    }
  }
  // 修改密码

  @action.bound
  async fetchSecurityPsd(data) {
    const result: any = await Axios.post(getExchangeUrl().changePassword, data).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      message.success(i18n.t('common.changePswSuccess'));
      this.toSignOut();
      return Promise.resolve(result);
    }
  }

  // 绑定谷歌

  @action.bound
  async fetchSecurityGoogle(
    data: any,
    options?: { successMessage?: string; showSuccessToast?: boolean },
  ) {
    const result: any = await Axios.post(getExchangeUrl().securityGoogle, data).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      const showToast = options?.showSuccessToast !== false;
      if (showToast) {
        message.success(options?.successMessage ?? i18n.t('common.bindSuccess'));
      }
      this.fetchUserInfo();
      return Promise.resolve(result);
    }
  }

  // 实名认证
  @action.bound
  async fetchIdentity(data) {
    const result: any = await Axios.post(getExchangeUrl().identity, data).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      message.success(i18n.t('common.submitSuccess'));
      this.fetchUserInfo();
      return Promise.resolve(result);
    }
  }

  // 谷歌二维码
  @action.bound
  async fetchGoogleQr() {
    const result: any = await Axios.get(getExchangeUrl().google).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      this.setGoogleQr(result);
    }
  }

  // 登录日志
  @action.bound
  async fetchLoginRecord(pageInfo?: { page?: number; size?: number }) {
    this.setLoadingState('isFetchingLoginRecord', true);

    const params = {
      page: this.loginRecordPageInfo.page,
      size: this.loginRecordPageInfo.size,
      ...pageInfo,
    };
    const result: any = await Axios.get(getExchangeUrl().loginRecord, { params }).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      const { items, page, ps: size, total } = result;
      this.setLoginRecord(items);
      this.setLoginRecordPageInfo({ page, size, total });
    }
    this.setLoadingState('isFetchingLoginRecord', false);
  }

  // 地址薄列表
  @action.bound
  async fetchAddressList(params) {
    this.setLoadingState('isFetchingAddressList', true);

    const result: any = await Axios.get(getExchangeUrl().addressList, { params }).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      this.setAddressList(result);
    }
    this.setLoadingState('isFetchingAddressList', false);
  }

  // 地址薄新增
  @action.bound
  async fetchAddAddress(data) {
    const result: any = await Axios.post(getExchangeUrl().addAddress, data).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      message.success(i18n.t('common.addSuccess'));
      // this.setAddAddress(result);
      return Promise.resolve(result);
    }
  }

  // 地址薄修改
  @action.bound
  async fetchUpdateAddress(data) {
    const result: any = await Axios.post(getExchangeUrl().updateAddress, data).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      message.success(i18n.t('common.changeSuccess'));
      return Promise.resolve(result);
    }
  }

  // 地址薄删除
  @action.bound
  async fetchDelAddress(data) {
    this.delLoading = true;

    const result: any = await Axios.post(getExchangeUrl().removeAddress, data).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      message.success(i18n.t('common.delSuccess'));
      // this.setAddAddress(result);
      this.delLoading = false;
      return Promise.resolve(result);
    }
  }

  // 充值币种地址获取
  @action.bound
  async fetchCoinAddress(params) {
    this.isShowAddress = false;

    const result: any = await Axios.get(getExchangeUrl().coinAddress, { params }).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      this.setLoadingState('isShowAddress', true);

      this.setCoinAddress(result);
    }
  }

  /** 切换充值币种时：清空网络与地址展示，待用户重新选链后再请求地址 */
  @action.bound
  resetDepositAddressUntilChainSelected() {
    this.isShowAddress = false;
    this.coinAddress = {
      account: '0',
      coinType: '',
      memo: '',
      address: '',
    };
  }

  // 是否内部地址
  @action.bound
  async fetchCheckAddress(params) {
    this.isShowAddress = false;

    const result: any = await Axios.get(getExchangeUrl().checkAddress, { params }).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      const { address, userId } = result;
      this.setLoadingState('isInsideAddres', address);
      this.setAddressUserId(userId);
    }
  }

  // 创建提现
  @action.bound
  async fetchCreateWithdraw(data) {
    const result: any = await Axios.post(getExchangeUrl().createWithdraw, data).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      message.success(i18n.t('common.desSuccess'));
    }
  }

  // // 谷歌密钥
  // @action.bound
  // async fetchGoogleQr(data) {
  //   const result: any = await Axios.get(getExchangeUrl().google, data).catch(({ error }: any) => {
  //        message.error(error);

  //   });

  //   if (result) {
  //     message.success(
  //     i18n.t('common.bindSuccess'),
  //
  //     );
  //   }
  // }
  // 判断用户是否存在
  @action.bound
  async fetchisExit(params) {
    const result: any = await Axios.get(getExchangeUrl().judge, { params }).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      const { judgeToken } = result;
      this.setJudgeToken(judgeToken);
      return result;
    }
  }

  // 国家码
  @action.bound
  async fetchCountryList() {
    const result: any = await Axios.get(getExchangeUrl().country).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      this.setCountryList(result);
    }
  }

  @action.bound
  async fetchLoginTokenInfo(data) {
    const result: any = await Axios.post(getExchangeUrl().loginToken, data).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      this.setLoginTokenInfo(result);
      return Promise.resolve(result);
    }
  }

  @action.bound
  async fetchSendCode(data) {
    const result: any = await Axios.post(getExchangeUrl().sendMsg, data).catch(({ error }: any) => {
      message.error(error);
    });

    message.success(i18n.t('captchaBtn.success'));
    return Promise.resolve(true);
  }
  @action.bound
  async fetchSendCodeLogin(data) {
    const result: any = await Axios.post(getExchangeUrl().sendMsgLogin, data).catch(({ error }: any) => {
      message.error(error);
    });

    message.success(i18n.t('captchaBtn.success'));
    return Promise.resolve(true);
  }
  // 极验init
  @action.bound
  async fetchInit() {
    const params = {
      //graphicType: 'ALIYUN',
      graphicType: 'GEETEST',
    };
    const result: any = await Axios.get(getExchangeUrl().init, { params });
    if (result) {
      return Promise.resolve(result);
    }
  }

  // 重置密码
  @action.bound
  async fetchReset(data) {
    const result: any = await Axios.post(getExchangeUrl().reset, data).catch(({ error }: any) => {
      message.error(error);
    });
    if (result) {
      return Promise.resolve(result);
    }
  }

  // 注册
  @action.bound
  async fetctRegister(data) {
    const result: any = await Axios.post(getExchangeUrl().registers, data).catch((error: any) => {
      message.error(error.msgInfo);
      return Promise.reject(error);
    });
    console.log('result', result);
    if (result) {
      message.success(i18n.t('signUp.success'));
      return Promise.resolve(result);
    }
  }

  // 站内信列表
  @action.bound
  async fetchZnxList({
    aggType,
    direction,
    limit = 20,
    id,
  }: {
    aggType?: string;
    direction?: ScrollPaginationDirection;
    id?: number;
    limit?: number;
  }) {
    const config: any = {
      params: {
        aggType,
        direction,
        limit,
        id,
      },
    };
    const result: any = await Axios.get(getExchangeUrl().znxList, config).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      switch (aggType) {
        case 'SYSTEM':
          this.setZnxList('znxSystemList', result);
          break;
        case 'DEPOSIT_WITHDRAW':
          this.setZnxList('znxDwList', result);
          break;
        case 'SAFE':
          this.setZnxList('znxSafeList', result);
          break;
        case 'AUTH':
          this.setZnxList('znxAuthList', result);
          break;
        case 'COPY_ORDER':
          this.setZnxList('znxCopyList', result);
          break;
        case 'CONTRACT':
          this.setZnxList('znxContractList', result);
          break;
      }
      return Promise.resolve(true);
    }
  }
  // 读取站内信消息
  @action.bound
  async fetchZnxRead(id?: { id: number }) {
    const result: any = await Axios.put(
      getExchangeUrl().znxRead,
      JSON.stringify({
        id,
      }),
      {
        headers: {
          'Content-Type': 'application/json', // 请求载荷
        },
      },
    ).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      // this.fetchZnxList({ aggType: 'SYSTEM' });
      return Promise.resolve(result);
    }
  }

  // 所有站内信列表
  @action.bound
  async fetchZnxListAll(params?: { direction?: ScrollPaginationDirection; limit?: number }) {
    const config: any = {
      params: {
        limit: 20,
        ...params,
      },
    };
    const result: any = await Axios.get(getExchangeUrl().znxListAll, config).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      const { AUTH, COPY_ORDER, CONTRACT, DEPOSIT_WITHDRAW, SAFE, SYSTEM } = result;
      this.setZnxListAll(result);

      this.setZnxList('znxSystemList', SYSTEM);
      this.setZnxList('znxDwList', DEPOSIT_WITHDRAW);
      this.setZnxList('znxSafeList', SAFE);
      this.setZnxList('znxAuthList', AUTH);
      this.setZnxList('znxCopyList', COPY_ORDER);
      this.setZnxList('znxContractList', CONTRACT);
    }
  }
  //全部已读
  @action.bound
  async fetchZnxReadAll() {
    const result: any = await Axios.put(getExchangeUrl().znxReadAll).catch(({ error }: any) => {
      message.error(error);
    });

    if (result) {
      // this.fetchZnxList({ aggType: 'SYSTEM' });
      message.success(i18n.t('message.allread'));
      this.fetchZnxListAll();
      return Promise.resolve(result);
    }
  }
  // 修改头像
  @action.bound
  async fetchChangeAvatar(data: any) {
    const result: any = await Axios.post(getExchangeUrl().changeAvatar, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).catch(({ error }: any) => {
      message.error(error);
    });
    if (result) {
      message.success(result.msg);
      this.fetchUserInfo();
      return Promise.resolve(result);
    }
  }

}
